import React from 'react'
import PropTypes from 'prop-types'

import { Modal, Button, BUTTON_THEME } from '@st-operations/uikit/src/v2/index.js'
import ProgressChart from '../progress-chart/index.jsx'

import './styles.scss'

const MODAL_CLASSES = {
  content: 'batch-process-modal__container',
  childWrapper: 'batch-process-modal__wrapper',
  innerWrapper: 'batch-process-modal__inner-wrapper',
  headerClose: 'batch-process-modal__close-button',
}

const BatchProcessModal = ({
  className,
  title,
  subtitle,
  buttonLabel,
  isOpen,
  onClose,
  onClick,
  percentage,
}) => {
  const close = () => {
    setTimeout(onClose, 500)
  }
  return (
    <Modal className={className} classes={MODAL_CLASSES} isOpen={isOpen} onClose={onClose}>
      <section className="batch-process-modal__content">
        <h1 className="batch-process-modal__title">{title}</h1>
        <p className="batch-process-modal__description">{subtitle}</p>
        <div className="batch-process-modal__progress-chart-wrapper">
          <ProgressChart className="batch-process-modal__progress-chart" percentage={percentage} />
        </div>
        <If condition={buttonLabel}>
          <Choose>
            <When condition={percentage !== 1}>
              <Button theme={BUTTON_THEME.SECONDARY} onClick={onClick}>
                {buttonLabel}
              </Button>
            </When>
            <Otherwise>{close()}</Otherwise>
          </Choose>
        </If>
      </section>
    </Modal>
  )
}

BatchProcessModal.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  percentage: PropTypes.number,
}

BatchProcessModal.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  buttonLabel: undefined,
  isOpen: false,
  onClose: () => {},
  onClick: () => {},
  percentage: 0,
}

export default React.memo(BatchProcessModal)
